module.exports = __webpack_public_path__ + "media/images/iconArrowRight-ba511ed17968478a74e30f3c6be19896.png";